import React, { FC, useCallback, useMemo } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { classValidatorResolver } from '@hookform/resolvers/class-validator'
import { Grid } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { RejectCommissionRequestDto } from '@sparling/financial-common'
import { InputField } from '../../../../components/InputField'
import { Modal } from '../../../../components/Modal'
import { rejectCommissionsModal } from '../../../../store/selectors'
import { rejectCommissionsRequest } from '../../../../store/actions'

interface CommissionsRejectModalProps {
  isOpen: boolean
  modalClose: () => void
  clearCheckedIds: () => void
}

export const CommissionsRejectModal: FC<CommissionsRejectModalProps> = ({ isOpen, modalClose, clearCheckedIds }) => {
  const dispatch = useDispatch()
  const { ids: commissions } = useSelector(rejectCommissionsModal)
  const formMethods = useForm({
    mode: 'all',
    reValidateMode: 'onChange',
    shouldFocusError: true,
    resolver: classValidatorResolver(RejectCommissionRequestDto),
    defaultValues: { commissions },
  })
  const {
    handleSubmit,
    reset,
    formState: { isValid },
  } = formMethods

  const onSubmit = useCallback(
    (data) => {
      dispatch(rejectCommissionsRequest({ reason: data.reason, commissions }))
      reset()
      clearCheckedIds()
    },
    [dispatch, reset, clearCheckedIds, commissions],
  )

  const isMany = useMemo(() => commissions.length > 1, [commissions])

  return (
    <Modal
      title={`Reject ${isMany ? 'selected' : ''} commission${isMany ? 's' : ''}`}
      submitTitle="Reject"
      isOpen={isOpen}
      modalClose={modalClose}
      onSubmit={handleSubmit(onSubmit)}
      isSubmitDisabled={!isValid}
    >
      <FormProvider {...formMethods}>
        <Grid container direction="column" minHeight={180}>
          <Grid item xs={12}>
            <InputField
              labelName={'Reject Reason'}
              inputName="reason"
              inputType="text"
              rows={6}
              withoutPadding
              fullWidth
              multiline
            />
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  )
}
